module.exports = __webpack_public_path__ + "img/lab.395cd1e4.jpg";